// Module
var code = "<sb-app-angular-js-note-comments id=\"{{ 'noteCommentsTimeline-' + noteComments.noteId }}\"></sb-app-angular-js-note-comments> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/common/ui-elements/directives/deliverables/sbDeliverableNoteComments/sb_deliverable_note_comments.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;